import { Term } from './term';

export class CourseInfo {
  id: string;
  instanceId: string;
  academicYear: string;
  startDate: Date;
  endDate: Date;
  terms: Term[];

  public constructor(data: Partial<Record<Exclude<keyof CourseInfo, 'id'>, any>>) {
    Object.assign(this, data);

    if (this.startDate > this.endDate) {
      let tempDate = this.startDate;
      this.startDate = this.endDate;
      this.endDate = tempDate;
    }

    this.id = `course-data-${this.startDate.getTime()}-${this.endDate.getTime()}`; // this id is also used to sort and dedupe items
  }
}
